import {
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_FAILURE,
    GET_TYPING_USERS_REQUEST,
    SET_USERS,
    SET_USER,
    SUBMIT_USER_SUCCESS,
    SUBMIT_USER_REQUEST,
    SUBMIT_USER_FAILURE,
    DELETE_USER_REQUEST,
    DELETE_USER_FAILURE,
    DELETE_USER_SUCCESS,
    SET_USERS_LIMIT,
    GET_ALL_USERS_REQUEST,
    GET_ALL_USERS_SUCCESS,
    GET_ALL_USERS_FAILURE,
    GET_USERS_AND_BOTS_SUCCESS
    
} from '../actions/users';
import { buildUsers, buildProfiles } from '../helpers/users';
const initialState = {
    fetching: false,
    typingFetching: false,
    submitFetching: false,
    submitSuccess: false,
    users: [],
    user: {},
    total: 0,
    deleteFetching: false,
    deleteSuccess: false,
    profiles: [],
    page:0,
    limit:10
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS_REQUEST: {
            return {
                ...state,
                fetching: true,
                submitSuccess: false
            };
        }
        case GET_TYPING_USERS_REQUEST: {
            return {
                ...state,
                typingFetching: true,
                users: [],
                total: 0
            };
        }
        case GET_USERS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                typingFetching: false,
                users: state.users.concat(buildUsers(action.payload.users, action.payload.profiles)),
                total: (!action.payload.total || action.payload.total === 0) ? state.total : action.payload.total,
                profiles: buildProfiles(action.payload.users)
            };
        }
        case GET_USERS_AND_BOTS_SUCCESS: {
            return {
                ...state,
                usersAndBots: action.payload.usersAndBots
            };
        }
        case GET_USERS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case GET_ALL_USERS_REQUEST: {
            return {
                ...state,
                fetching: true,
                submitSuccess: false
            };
        }
        case GET_ALL_USERS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                typingFetching: false,
                users: state.users.concat(buildUsers(action.payload.users, action.payload.profiles)),
                total: (!action.payload.total || action.payload.total === 0) ? state.total : action.payload.total,
                profiles: buildProfiles(action.payload.users)
            };
        }
        case GET_ALL_USERS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_USERS: {
            return {
                ...state,
                users: action.payload.users,
                total: action.payload.total
            };
        }
        case SET_USERS_LIMIT:
            return {
                ...state,
                limit: action.payload.limit,
            }
        case SET_USER: {
            return {
                ...state,
                user: action.payload.user
            };
        }

        case SUBMIT_USER_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_USER_SUCCESS: {
            return {
                ...state,
                user: action.payload.user,
                submitFetching: false,
                submitSuccess: true
            };
        }
        case SUBMIT_USER_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case DELETE_USER_REQUEST: {
            return {
                ...state,
                deleteFetching: true,
                deleteSuccess: false
            };
        }
        case DELETE_USER_SUCCESS: {
            return {
                ...state,
                deleteFetching: false,
                deleteSuccess: true
            };
        }
        case DELETE_USER_FAILURE: {
            return {
                ...state,
                deleteFetching: false,
                deleteSuccess: false
            };
        }

        default:
            return state;
    }
};
